import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import get from 'lodash/get';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';
import { Block, Icon, Select } from '../components';
import { useDeleteIndustryMutation, useGetIndustriesQuery } from '../../api/industryApiSlice';
import useActionConfirmation from '../useActionConfirmation';
import NewIndustryModal from './NewIndustryModal';

const IndustrySelection = ({currentIndustry, setCurrentIndustry})=>{
  const { t } = useTranslation();
  const [newModalShow, setNewModalShow] = useState(false);
  const setCurrentIndustryById = (id)=>(setCurrentIndustry(industries.find((ind) => ind['id'] == id) || {}));
  const {data: industries = [], isSuccess, isLoading } = useGetIndustriesQuery();

  const [isDeleteDisabled, setIsDeleteDisabled] = useState(true)
  const {Confirmation: DeleteConfirmation, confirmationProps: deleteConfirmationProps, confirm: deleteConfirm} = useActionConfirmation()
  const [deleteIndustry] = useDeleteIndustryMutation()
  const deleteConfirmation = () => {
    deleteIndustry(currentIndustry.id)
    setCurrentIndustry({})
  }

  useEffect(() => {
    const industryId = currentIndustry.id ? currentIndustry.id : 0
    setIsDeleteDisabled(!industryId)
  }, [currentIndustry])

  return (
    <>
      <Block>
        <Row>
          <Col>
            <Select
              options={ [{value: 0, label: t("all")} , ...industries.map((i)=>({value: i.id, label: i.name}))] }
              value={get(currentIndustry, 'id', 0)}
              onChange={(id)=>(setCurrentIndustryById(id))}
            />
          </Col>
          <Col xl={4} lg={5} md={6}>
            <ButtonGroup className="mb-2">
              <Button onClick={()=>(setNewModalShow(true))}>
                <Icon icon='plus' text={t("new")} />
              </Button>
              <Button variant="danger" onClick={()=>deleteConfirm(() => deleteConfirmation())} disabled={isDeleteDisabled}>
                <Icon icon='trash' text={t("delete")} />
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
      </Block>
      <NewIndustryModal show={newModalShow} onClose={()=>{setNewModalShow(false)}}/>
      <DeleteConfirmation placeholder="Please enter industrie name" {...deleteConfirmationProps} confirmValue={currentIndustry['name']} deletion={true}/>
    </>
  )
}

export default IndustrySelection;